import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import { Alert, Icon, Layout, Table, Button, Tooltip, message } from "antd";
import { Link } from "react-router-dom";

import classes from "./DelegationLogs.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  delegationLogLockRequest,
  delegationLogUnlockRequest,
  delegationLogApproveRequest,
  getDelegationLogsSigningRequest,
  getSitesRequest,
  getUsersLight,
  delegationLogDisableRequest,
  previewDelegationLogPdf,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { getDelegationLogAdminCreatePermission } from "../../reducers/user/selectors";

import { withNamespaces } from "react-i18next";
import { withParams } from "../../utils/url";

const routes = require("../../routes.json");

const { Content } = Layout;

class DelegationLogsSigning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      delegationLogs: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      users: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      sortedInfo: { columnKey: "order_index", order: "ascend" },
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      duplicateLogId: null,
      deleteLogId: null,
      versionUpId: null,
      deleteLogIdLoading: null,
      loadingPdf: [],
      loadingVersionUp: [],
    };
  }

  async componentDidMount() {
    this.onNameSearch();
    this.getSites();
    this.getUsers();
  }

  getUsers = async () => {
    try {
      const { data: users } = await getUsersLight();
      this.setState({ users });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  getSites = async () => {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
      }
    }
  };

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getDelegationLogs
    );
  };

  getDelegationLogs = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDelegationLogsSigningRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });

      this.setState({
        delegationLogs: data.sort((a, b) => a.id - b.id),
        total: data.total_pages * per_page,
        currentPage: page,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        delegationLogs: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getDelegationLogs(pagination.current, pagination.pageSize)
    );
  };

  onDelegationLogEdit = (document) => () => {
    this.setState({ delegationLogEdit: document });
  };

  onDelegationLogEditHide = () => {
    this.setState({ delegationLogEdit: null });
  };

  onDelegationLogEditSubmit = () => {
    this.setState({ delegationLogEdit: null }, this.getDelegationLogs);
  };

  addDelegationLog = () => {
    this.setState({ delegationLogEdit: {} });
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1, };
    }, this.getDelegationLogs);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1, }, this.getDelegationLogs);
  };

  onSwitchApprove = async (id) => {
    try {
      await delegationLogApproveRequest({ id });
      message.success(this.props.i18n.t("Saved"));
      this.getDelegationLogs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
    }
  };

  onSwitchLock = (id, status) => async () => {
    try {
      if (["ready_to_be_signed", "qi_signed"].includes(status)) {
        await delegationLogLockRequest({ id });
      } else {
        await delegationLogUnlockRequest({ id });
      }

      message.success(this.props.i18n.t("Saved"));

      this.getDelegationLogs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  previewReport = async (id) => {
    try {
      this.setState((state) => ({
        loadingPdf: { ...state.loadingPdf, [id]: true },
      }));

      let data = null;

      const response = await previewDelegationLogPdf(id);
      data = response.data;

      const blob = new Blob([data], { type: "application/pdf" });
      // const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      // link.download = `delegation-log-${id}.pdf`;
      link.target = "_blank";
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState((state) => ({
      loadingPdf: { ...state.loadingPdf, [id]: false },
    }));
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      delegationLogs,
      sites,
      sortedInfo,
    } = this.state;

    const columns = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("ID"),
        render: (val) => <span>{val}</span>,
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site"),
        render: (val) =>
          get(val, "name") && (
            <span>
              {get(val, "code")} - {get(val, "name")}
            </span>
          ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "site" && sortedInfo.order,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Status"),
        render: (val) => <span>{val.replace(/_/g, " ")}</span>,
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "major_version",
        key: "major_version",
        title: this.props.i18n.t("Version"),
        render: (val, row) => (
          <span>
            {val}
            {row.minor_version}
          </span>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "current_user_role",
        key: "current_user_role",
        title: this.props.i18n.t("NamespaceDelegationLogs:Your role"),
        render: (val) => (
          <div>
            {map(val, ({ id, name }) => (
              <div key={id}>{name}</div>
            ))}
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "my_tasks",
        key: "my_tasks",
        title: this.props.i18n.t("NamespaceDelegationLogs:Your tasks"),
        render: (val) => (
          <div>
            {map(val, (task, i) => (
              <div key={i}>{task}</div>
            ))}
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "is_qi",
        key: "is_qi",
        title: this.props.i18n.t("NamespaceDelegationLogs:QI role"),
        render: (val) => (
          <div>
            {val && <Icon type="check-square" className={classes.checkIcon} />}
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "user_signature_status",
        key: "user_signature_status",
        title: this.props.i18n.t("NamespaceDelegationLogs:Your signature status"),
        render: (val) => <div>{val.replace(/_/g, " ")}</div>,
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "is_locked",
        key: "is_locked",
        title: this.props.i18n.t("Is locked"),
        render: (val) => <div>{val ? "Yes" : "No"}</div>,
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "actions",
        title: this.props.i18n.t("NamespaceDelegationLogs:Actions"),
        width: 250,
        render: (val, row) => (
          <div className={classes.actions}>
            <div>

              {row.required_signatures.includes("qi_start_of_delegation_signature") && (
                <div style={{ margin: '0 0 5px' }}>
                  <Link
                    to={withParams(routes.admin.delegationLogsSigningForm, {
                      id: row.id,
                      type: 'qi_start_of_delegation_signature'
                    })}
                  >
                    <Button type="primary" size="small">
                      {this.props.i18n.t("NamespaceDelegationLogs:QI start of delegation signature")}
                    </Button>
                  </Link>
                </div>
              )}
              {row.required_signatures.includes("qi_staff_changed_signature") && (
                <div style={{ margin: '0 0 5px' }}>
                  <Link
                    to={withParams(routes.admin.delegationLogsSigningForm, {
                      id: row.id,
                      type: 'qi_staff_changed_signature'
                    })}
                  >
                    <Button type="primary" size="small">
                      {this.props.i18n.t("NamespaceDelegationLogs:QI confirm staff changes signature")}
                    </Button>
                  </Link>
                </div>
              )}

              {row.required_signatures.includes("staff_signature") && (
                <div style={{ margin: '0 0 5px' }}>
                  <Link
                    to={withParams(routes.admin.delegationLogsSigningForm, {
                      id: row.id,
                      type: 'staff_signature',
                    })}
                  >
                    <Button type="primary" size="small">
                      Staff member signature
                    </Button>
                  </Link>
                </div>
              )}

              {row.required_signatures.includes("qi_staff_confirmed_signature") && (
                <div style={{ margin: '0 0 5px' }}>
                  <Link
                    to={withParams(routes.admin.delegationLogsSigningForm, {
                      id: row.id,
                      type: 'qi_staff_confirmed_signature'
                    })}
                  >
                    <Button type="primary" size="small">
                      QI confirm all staff signature
                    </Button>
                  </Link>
                </div>
              )}
              {row.required_signatures.includes("qi_end_of_study_signature") && (
                <div style={{ margin: '0 0 5px' }}>
                  <Link
                    to={withParams(routes.admin.delegationLogsSigningForm, {
                      id: row.id,
                      type: 'qi_end_of_study_signature'
                    })}
                  >
                    <Button type="primary" size="small">
                      QI confirm End of Study signature
                    </Button>
                  </Link>
                </div>
              )}
            </div>

            {row.allow_preview_log && (
              <Button
                style={{ margin: "0 10px 5px" }}
                size="small"
                onClick={() => {
                  this.previewReport(row.id);
                }}
                disabled={this.state.loadingPdf[val]}
                loading={this.state.loadingPdf[val]}
              >
                {row.status === 'end_of_study' ? 'View' : 'Preview'}
              </Button>
            )}
          </div>
        ),
      },
    ];

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t(
                "NamespaceDelegationLogs:Delegation Log Signing List"
              )}
            </h3>
            <br />

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <Table
              columns={columns}
              dataSource={delegationLogs}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={false}
            />
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogAdminCreatePermission: getDelegationLogAdminCreatePermission(
    state
  ),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DelegationLogsSigning))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/DelegationLogsSigning.js